// Global flag to track if navigation is happening from header
// This avoids Redux async timing issues
let skipBottomSheetNavigation = false;

export const setSkipBottomSheetNavigation = (value: boolean) => {
  skipBottomSheetNavigation = value;
};

export const getSkipBottomSheetNavigation = () => {
  return skipBottomSheetNavigation;
};

export const resetSkipBottomSheetNavigation = () => {
  skipBottomSheetNavigation = false;
};
